<template>
  <nav class="mt-10 flex-shrink-0 relative p-5 flex-col bg-white lg:w-80 md:w-80 w-screen border border-gray-200 rounded ml-7">
    <h2 class="text-gray-900 text-left border-b border-gray-700 pb-2 font-bold"> FILTER </h2>
    <ul class="max-h-full p-4 overflow-y-auto border-b border-gray-700 mb-3">
      <Category
      v-for="category in categories"
      :key="category.id"
      :category="category" />
    </ul>
    <div class="mx-5">
      <button
      @click.prevent="viewAll"
      class="bg-red-700 text-gray-100 w-full text-white py-2 font-bold rounded cursor-pointer hover:bg-red-900">FIND ALL</button>
    </div>
  </nav>
</template>

<script>
import Category from './Category.vue'
// import Card from './Card.vue'
export default {
  components: { Category },
  name: 'Sidebar',
  methods: {
    fetchCategories () {
      this.$store.dispatch('fetchCategories')
    },
    viewAll () {
      this.$store.dispatch('fetchTenants')
    }
  },
  created () {
    this.fetchCategories()
  },
  computed: {
    categories () {
      return this.$store.state.categories
    }
  }
}
</script>

<style>
/* Rotate chevron in collapsing */
    [data-bs-toggle='collapse'][aria-expanded='true'] span:nth-child(3) svg {
      transform: rotate(-90deg);
    }
    /* For bootstrap collapse plugin */
    .fade {
      transition: opacity 0.15s linear;
    }
    .fade:not(.show) {
      opacity: 0;
    }
    .collapse:not(.show) {
      display: none;
    }
    .collapsing {
      height: 0;
      overflow: hidden;
      transition: height 0.35s ease;
    }
    @media (prefers-grayuced-motion: reduce) {
      .collapsing {
        transition: none;
      }
      .fade {
        transition: none;
      }
    }
    /* fixed github link. this stuff also should be applied throw config file  */
    .github-link:hover {
      box-shadow: inset -4px -4px 10px rgb(255, 255, 255), inset 4px 4px 10px rgba(0, 0, 0, 0.219);
    }
    .github-link:hover > svg,
    .github-link:focus > svg {
      transform: scale(.95)
    }
</style>
